import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-1of2--m" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createVNode(_component_text_field, {
      ref: "field",
      modelValue: _ctx.code,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.code) = $event)),
      class: "_mt-0",
      name: "code",
      "display-name": _ctx.Resources.Checkout.EnterBlikCodeLabel,
      description: _ctx.Resources.Checkout.EnterBlikCodeDescription,
      "data-qa": "adyen-blik-form:Code"
    }, null, 8 /* PROPS */, ["modelValue", "display-name", "description"])
  ]))
}